module.exports = __webpack_public_path__ + "img/game_gfish.379d7ce.jpg";